<script>
  import dialogMixin from "./mixins/dialog";

  export default {
    mixins: [dialogMixin],
    props: {

    },
    data() {
      return {}
    },
    computed: {

    },
    methods: {
      goToResiger() {
        this.$emit('toResiger', true)
      }
    },
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogDealer } isStyleDealer`"
    width="583px"
    append-to-body
  >
    <div class="sectionTitle text-center font-medium color-gray-7">手機號未註冊</div>
    <div class="text-base md:text-lg dialogDealer__content text-md-left text-center">
      <p>Oops! 
        <br>系統查無此註冊手機號。請重新
        <BaseButton
          class="isStylePrimary isTextUnderline"
          style="margin-left: -0.4em;"
          @click="goToResiger"
        >
          註冊會員
        </BaseButton></p>
    </div>
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogDealer {
    // padding-right: 30px;
    // padding-left: 30px;
    :global {
    
    }
  }
</style>
